import { Button } from '@mui/material';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { PermissionBoundary } from '../../../../../../core/permissions/permission-boundary.component';
import { NavigationItem } from '../../navigation-bar.component';
import { useNavMenuDesktopItemStyles } from './nav-menu-desktop-item.styles';

export function NavMenuDesktopItem({ item }: { item: NavigationItem }) {
  const match = useRouteMatch({ path: item.url, exact: true });
  const classes = useNavMenuDesktopItemStyles({ isSelected: match?.isExact });
  return (
    <PermissionBoundary
      key={`${item.text}${item.url}`}
      permissions={item.permissions}
      availableUiFeatures={item.availableUiFeatures}
    >
      <Button
        {...(item.url ? { component: NavLink, to: item.url } : {})}
        className={classes.menuItemsDesktop__button}
        variant="contained"
      >
        {item.text}
      </Button>
    </PermissionBoundary>
  );
}
